<template>
    <v-app :dark="dark_theme">
        <v-snackbar
                v-model="snackbar.show"
                :color="snackbar.color"
                :bottom="snackbar.y === 'bottom'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
        >
            {{ $vuetify.t(snackbar.text) }}
            <v-btn icon @click="snackbar.show = false">
                <v-icon color="white">fal fa-times</v-icon>
            </v-btn>
        </v-snackbar>
        <router-view/>
    </v-app>
</template>

<script>

export default {
    data: () => ({
        dark_theme: true,
        snackbar: {
            show: false,
            y: 'top', // or top
            x: null,
            multiLine: true,
            mode: '',
            timeout: 3000,
            text: '',
            color: ''
        }
    }),
    computed: {
        loading() {
            return this.$store.state.loader.loading;
        },
        alertTrigger() {
            return this.$store.state.alert.trigger;
        }

    },
    watch: {
        loading(newState) {
            if (newState) {
                this.loader = this.$loading.show({
                    // Optional parameters
                    container: null,
                    color: this.$vuetify.theme.primary,
                    loader: "spinner",
                    height: 50,
                    backgroundColor: "#333",
                    opacity: 0.8,
                    canCancel: false
                });
            } else {
                if (this.loader !== undefined) this.loader.hide();
            }
        },
        alertTrigger(newState) {
            if (newState > 0) {
                this.snackbar.text = this.$vuetify.t(this.$store.state.alert.message);
                //this.snackbar.color = this.$store.state.alert.color;
                this.snackbar.y = 'bottom';
                this.snackbar.show = true;
            } else {
                this.snackbar.show = false;
            }
        }
    },
    mounted() {
        //TODO inserir isto na STORE!
        this.dark_theme = process.env.VUE_APP_VUETIFY_DARK_THEME === "True";
    }
}
</script>

<style>
/*Hide recaptcha!
 https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-badge-what-is-allowed
 */
.grecaptcha-badge {
    visibility: hidden;
}

/*
@font-face {
  font-family: 'Gotham-Black';
  src: url('./assets/fonts/Gotham-Black.woff2') format('woff2'),
  url('./assets/fonts/Gotham-Black.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
*/

</style>